import React from 'react';
import Header from 'components/common/Header';
import Sidebar from 'components/common/Sidebar';
import Footer from 'components/common/Footer';

const Layout = ({ children, title, tagline }) => {
    return (
        <div className="admin-layout">
            {/* Sidebar on the left */}
            <Sidebar />
            
            {/* Main wrapper for right side content */}
            <div className="admin-wrapper">
                <Header title={title} tagline={tagline} />
                
                <main className="admin-main">
                    {children}
                </main>

                <Footer />
            </div>
        </div>
    );
};

export default Layout;
